const darkVariant = {
	name: "dark",
	palette: {
		primary: {
			main: "#1F1F1F",
			900: "#252525",
			850: "#2D2D2D",
			800: "#3C3C3C",
			750: "#434343",
			700: "#929292",
		},
		secondary: {
			main: "#FFBD59",
			50: "#FFBD5980"
		},
		third: {
			100: "#FFFFFF",
			50: "#FFFFFF80",
			10: "#FFFFFF1A"
		}
	},
	header: {
		color: "#FFFFFF",
		background: "#2D2D2D",
		search: {
			background: "#252525",
			text_container_background: "#514430"
		},
		indicator: {
			background: "#E02020"
		}
	},
	sidebar: {
		color: "#FFFFFF",
		background: "#1F1F1F",
		header: {
			color: '#FFFFFF',
			background: "#1F1F1F"
		},
		footer: {
			background: "#1F1F1F"
		},
		item: {
			hoverBackground: "#FFFFFF1A",
			activeLinearBackgroundColor1: "#FFBD59",
			activeLinearBackgroundColor2: "#FFBD5963",
		},
		badge: {
			color: "#000",
			background: "#FFF"
		}
	},
	body: {
		auth: {
			background: "#252525",
			color: "#FFFFFF"
		},
		dashboard: {
			background: "#252525",
			color: "#FFFFFF"
		}
	}
};

const lightVariant = {
	name: "light",
	palette: {
		primary: {
			main: "#F1F1F1",
			900: "#E8E8E9",
			850: "#F1F1F1",
			800: "#3C3C3C",
			750: "#F1F1F1",
			700: "#929292",
		},
		secondary: {
			main: "#FFBD59",
			50: "#FFBD5980"
		},
		third: {
			100: "#1F1F1F",
			50: "#1F1F1F80",
			10: "#1F1F1F1A"
		}
	},
	header: {
		color: "#1F1F1F",
		background: "#F1F1F1",
		search: {
			background: "#252525",
			text_container_background: "#F7EAD6"
		},
		indicator: {
			background: "#E02020"
		}
	},
	sidebar: {
		color: "#FFFFFF",
		background: "#1F1F1F",
		header: {
			color: '#FFFFFF',
			background: "#1F1F1F"
		},
		footer: {
			background: "#1F1F1F"
		},
		item: {
			hoverBackground: "#FFFFFF1A",
			activeLinearBackgroundColor1: "#FFBD59",
			activeLinearBackgroundColor2: "#FFBD5963",
		},
		badge: {
			color: "#000",
			background: "#FFF"
		}
	},
	body: {
		auth: {
			background: "#FAFBFD",
			color: "#1F1F1F"
		},
		dashboard: {
			background: "#FFFFFF",
			color: "#1F1F1F"
		}
	}
};

const variant = {
	'dark': darkVariant,
	'light': lightVariant
};

export default variant;
